import { useNavigate } from 'react-router-dom';
import { useAppRoutes } from 'hx-util';
import usePathIndex from './usePathIndex';
import { findRouteByPath } from '../functions/findRouteByPath';
export var useNavigator = function (_a) {
    var _b = _a === void 0 ? {} : _a, exitRoute = _b.exitRoute, fromRoute = _b.fromRoute, shouldSkip = _b.shouldSkip, onComplete = _b.onComplete, onNext = _b.onNext, nextGuard = _b.nextGuard, phaseLength = _b.phaseLength;
    var navigate = useNavigate();
    var _c = usePathIndex(), pathIndex = _c.pathIndex, basePath = _c.basePath, path = _c.path;
    var appRoutes = useAppRoutes();
    var baseRoute = findRouteByPath(appRoutes, "/".concat(basePath));
    var activeRoute = findRouteByPath(appRoutes, "/".concat(basePath ? basePath : path));
    var activeRouteIndex = activeRoute && appRoutes.indexOf(activeRoute);
    // if (typeof activeRouteIndex === 'undefined')
    //   throw new Error('Could not find active route');
    var isEndOfPhase = function (pathIndex) {
        var _a;
        if ((_a = baseRoute === null || baseRoute === void 0 ? void 0 : baseRoute.children) === null || _a === void 0 ? void 0 : _a.length)
            return pathIndex >= baseRoute.children.length - 1;
        if (!phaseLength)
            return true;
        return phaseLength && pathIndex >= phaseLength;
    };
    var getExitRoutePath = function () {
        return exitRoute || appRoutes[(activeRouteIndex || 0) + 1].path || '/';
    };
    var next = function () {
        var _a, _b;
        var stepSize = (shouldSkip === null || shouldSkip === void 0 ? void 0 : shouldSkip[pathIndex + 1 || 0]) ? 2 : 1;
        var nextIndex = pathIndex + stepSize;
        if ((nextGuard === null || nextGuard === void 0 ? void 0 : nextGuard()) === false)
            return;
        if (onNext)
            onNext();
        if (isEndOfPhase(pathIndex)) {
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            navigate(getExitRoutePath());
        }
        else {
            if ((_a = baseRoute === null || baseRoute === void 0 ? void 0 : baseRoute.children) === null || _a === void 0 ? void 0 : _a.length)
                navigate("/".concat(basePath, "/").concat((_b = baseRoute === null || baseRoute === void 0 ? void 0 : baseRoute.children) === null || _b === void 0 ? void 0 : _b[nextIndex].path));
            else
                navigate("/".concat(basePath, "/").concat(nextIndex));
        }
    };
    var back = function () {
        var _a;
        var step = (shouldSkip === null || shouldSkip === void 0 ? void 0 : shouldSkip[pathIndex - 1 || 0]) ? 2 : 1;
        var nextIndex = pathIndex - step;
        if (nextIndex === 0)
            goToPreviousRoute();
        else if (nextIndex === 0 && fromRoute)
            navigate(fromRoute);
        else
            navigate("/".concat(basePath, "/").concat(((_a = baseRoute === null || baseRoute === void 0 ? void 0 : baseRoute.children) === null || _a === void 0 ? void 0 : _a[nextIndex].path) || nextIndex));
    };
    var goToPreviousRoute = function () {
        var _a;
        if (typeof activeRouteIndex === 'undefined' || activeRouteIndex === 0)
            return;
        navigate(((_a = appRoutes[activeRouteIndex - 1]) === null || _a === void 0 ? void 0 : _a.path) || '/');
    };
    return { next: next, back: back, navigate: navigate, pathIndex: pathIndex, path: path };
};
export default useNavigator;
